import { useState } from 'react';
import { Link } from 'react-router-dom';
import { rankingByViews, rankingByRating } from '@/mocks/anime';

type RankingTab = 'views' | 'rating';

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState<RankingTab>('views');

  const data = activeTab === 'views' ? rankingByViews : rankingByRating;

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
      <div className="text-center mb-8">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
          排行榜
        </h2>
        <p className="text-sm text-foreground-500">最受欢迎的动漫作品一览</p>
      </div>

      <div className="flex justify-center mb-6">
        <div className="inline-flex bg-background-100 rounded-full p-1">
          <button
            onClick={() => setActiveTab('views')}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'views'
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-600 hover:text-foreground-800'
            }`}
          >
            人气排行
          </button>
          <button
            onClick={() => setActiveTab('rating')}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'rating'
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-600 hover:text-foreground-800'
            }`}
          >
            评分排行
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {data.slice(0, 9).map((anime, idx) => (
          <Link
            key={anime.id}
            to={`/article/${anime.slug}`}
            className="group flex items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 transition-all cursor-pointer"
          >
            <div className="relative shrink-0">
              <span className={`absolute -top-1 -left-1 w-6 h-6 rounded-full flex items-center justify-center text-xs font-heading text-background-50 ${
                idx === 0 ? 'bg-accent-500' :
                idx === 1 ? 'bg-accent-400' :
                idx === 2 ? 'bg-secondary-500' :
                'bg-foreground-400'
              }`}>
                {idx + 1}
              </span>
              <div className="w-14 h-18 rounded-lg overflow-hidden">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  title={`${anime.title} - 51动漫网`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                {anime.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-400">{anime.categories[0]}</span>
                <span className="text-xs text-foreground-300">·</span>
                <span className="text-xs text-foreground-400">{anime.status}</span>
              </div>
              <div className="flex items-center gap-2 mt-1">
                <div className="flex items-center gap-0.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs text-foreground-600 font-medium">{anime.rating}</span>
                </div>
                <span className="text-xs text-foreground-400">
                  {(anime.views / 10000).toFixed(0)}万 人气
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}